

import {
    ACTION_SET_BOOK_NAME,
    ACTION_SET_TOGGLE_BOOK_NAME,
    ACTION_SET_TOGGLE_IMPORT_WAY,
    ACTION_SET_UP_BOOK_INFO,
    ACTION_SET_EDITOR_BOOK_INFO,
} from './actions'


export default {
    //拆解的单词信息
    book_name(state = '', action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_BOOK_NAME:
                return payload
        }
        return state;
    },
    up_book_info(state = {}, action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_UP_BOOK_INFO:
                return payload
        }
        return state;
    },
    home_toggle_book_name(state = false, action) {
        const { type, payload } = action;
        if (type == ACTION_SET_TOGGLE_BOOK_NAME) {
            return payload;
        }
        return state;
    },
    home_toggle_import_way(state = false, action) {
        const { type, payload } = action;
        if (type == ACTION_SET_TOGGLE_IMPORT_WAY) {
            return payload;
        }

        return state;

    }

}